import { render, staticRenderFns } from "./ModalAddSection.vue?vue&type=template&id=52c9786c&scoped=true&lang=pug"
import script from "./ModalAddSection.vue?vue&type=script&lang=js"
export * from "./ModalAddSection.vue?vue&type=script&lang=js"
import style0 from "./ModalAddSection.vue?vue&type=style&index=0&id=52c9786c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c9786c",
  null
  
)

export default component.exports